import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "content" }
const _hoisted_2 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReglePastille = _resolveComponent("ReglePastille")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", null, [
      _createTextVNode(_toDisplayString(_ctx.$t('dashboard.fournisseur.reglement.title')) + " ", 1),
      _createVNode(_component_ReglePastille, { cle: "dashboardFournisseur.derniersReglements" })
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reglements, (reglement) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "items-container",
        key: reglement.id
      }, [
        _createElementVNode("div", {
          class: "reglement border-radius item",
          onClick: ($event: any) => (_ctx.goToReglement(reglement.id))
        }, [
          _createElementVNode("span", null, _toDisplayString(_ctx.formattedDate(reglement.dateReglement)), 1),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('dashboard.fournisseur.reglement.montant')) + " ", 1),
          _createElementVNode("span", null, _toDisplayString(_ctx.formattedMontant(reglement.montantTTC)), 1),
          _createTextVNode(" " + _toDisplayString(_ctx.transformeDevise(reglement.devise)), 1)
        ], 8, _hoisted_2)
      ]))
    }), 128))
  ]))
}